import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchAllDepartments(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('clinic/admin/specialization')
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

     
    createDepartment(ctx, userData) {
      return new Promise((resolve, reject) => {
        axios
          .post('clinic/admin/specialization',  userData  )
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    updateblogtag(ctx, userData) {
      return new Promise((resolve, reject) => {
        axios
          .put('clinic/admin/specialization',  userData  )
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    


  },
}
